import { useMemo } from "react";
import { useCurrency } from "@/hooks/use-currency";

// Custom hook for common formatters
export const useReportFormatters = () => {
  const currency = useCurrency();

  const formatters = useMemo(
    () => ({
      gmv: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 2,
      }),
      number: new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 1,
      }),
      video: new Intl.NumberFormat("en-US", {
        compactDisplay: "short",
        notation: "compact",
      }),
      percent: new Intl.NumberFormat("en-US", {
        style: "percent",
        compactDisplay: "short",
        notation: "compact",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }),
    }),
    [currency],
  );

  return formatters;
};
